<template>
	<Loader v-if="loading" />
	<div v-else class="content">

		<Modal
			v-if="move_result"
			v-on:close="move_result = null">
			<div
				class="flex"
				v-for="(result, sid) in move_result">
				<div
					style="width: 90px">
					#{{ sid }}
				</div>
				<div>
					<span
						class="green"
						v-if="result === true">
						OK
					</span>
					<span
						class="error"
						v-else>
						{{ result }}
					</span>
				</div>
			</div>
		</Modal>

		<Modal
			v-if="details"
			v-on:close="details = null">

			<table
				class="margin-bottom">
				<tr>
					<td
						v-for="(day, i) in getDays">
						<strong>{{ ! i ? 'Today' : 'T+' + i }}</strong>
						<div>{{ day }}</div>
					</td>
				</tr>
			</table>

			<table>
				<thead>
					<tr>
						<th>#</th>
						<th>By customer</th>
						<th>Orders in past 60 days</th>
						<th>Earliest move date</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="detail in details">
						<td style="width: 80px;">
							<a :href="'/#/subscription/' + detail.id">{{ detail.id }}</a>
						</td>
						<td>
							<div
								class="error"
								v-if="detail._by_customer">Yes</div>
							<div
								v-else>-</div>
						</td>
						<td>
							<div
								class="error"
								v-if="detail._has_recent_orders">Yes</div>
							<div
								v-else>-</div>
						</td>
						<td>
							<span
								v-bind:class="{
									green: isInPast(detail._earliest_move_date),
									error: !isInPast(detail._earliest_move_date),
								}">
								{{ parseDate(detail._earliest_move_date) }}
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</Modal>

		<div
			class="flex"
			>
			<div
				class="flex-grow"
				>
				<h1>Renewal statistics</h1>

				<p>
					<strong>Note:</strong>
					Subscriptions that are in failed payment state will <em>not</em> be shown or counted in this list!
				</p>
			</div>
			<div>
				<input
					type="date"
					v-model="request.from"
					/>
				<input
					type="date"
					v-model="request.to"
					class="xs-margin-left"
					/>
				<button
					class="small gray xs-margin-left"
					v-on:click="load"
					:disabled="loading"
					>Go</button>
			</div>
		</div>

		<Modal
			v-if="move"
			v-on:close="move = false;"
			>
			<div class="input-row small-margin-bottom">
				<span class="label">Date</span>
				{{ move.date }}
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">From country</span>
				<Flag :countryid="move.country_id" />
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Subscriptions to move</span>
				<input type="number" min="1" :max="move.count" v-model="move.move_count" />
			</div>
			<div class="input-row small-margin-bottom">
				<span class="label">Move to</span>
				<input type="date" v-model="move.move_to_date" />
			</div>
			<button :disabled="saving" v-on:click="confirmMove()">Confirm</button>
		</Modal>

		<div class="margin-top">
			<table>
				<thead>
					<tr>
						<th>Date</th>
						<th v-for="country in getCountries">
							<Flag :countryid="country.id" />
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(record, date) in records">
						<td>
							<Format type="date" :value="date" />
						</td>
						<td v-for="country in getCountries">
							<button
								class="white small"
								v-on:click="details = filterSubscriptions(record, country, false)">
								{{ filterSubscriptions(record, country, false).length }}
							</button>

							<button
								:disabled="!filterSubscriptions(record, country, true).length"
								class="white small margin-left"
								v-on:click="open(date, filterSubscriptions(record, country, true), country)">
									{{ filterSubscriptions(record, country, true).length }}
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getCountries'
    ]),
    getDays () {
    	var list = []
    	var count = 0
    	var counted = []

    	for (var i = 0; i <= 4; i++) {
    		const dt = new Date((new Date()).getTime() + i * 1000 * 24 * 60 * 60)
    		const dtm = Vue.$create.dateTime(dt)

    		for (var date in this.records) {
    			for (var subscription of this.records[date]) {
    				if (
    					subscription._by_customer ||
    					subscription._has_recent_orders ||
    					subscription._earliest_move_date > dtm.format('Y-m-d') ||
    					counted.indexOf(subscription.id) >= 0
    				) {
    					continue
    				}

    				counted.push(subscription.id)

    				count++
    			}
    		}

    		list.push(count)
    	}
    	return list
    }
  },
  data: () => ({
    loading: false,
    saving: false,
    records: [],
    move: false,
    move_result: null,
    details: null,
    request: {
      from: null,
      to: null
    }
  }),
  methods: {
  	parseDate (date) {
  		// console.log(date, Vue.$create.dateTime(date).format('Y-m-d'))
  		if (date <= Vue.$create.dateTime().format('Y-m-d')) {
  			return 'Today'
  		}

  		return date
  	},
    filterSubscriptions (subscriptions, country, filterUnrenewable) {
      var list = []

      for (var subscription of subscriptions) {
        if (
          subscription._locale_id == country.id &&
						(
						  !filterUnrenewable ||
							(
							  !subscription._by_customer &&
								!subscription._has_recent_orders
							)
						)
        ) {
          list.push(subscription)
        }
      }

      return list
    },
    confirmMove () {
      Vue.$api.post('/new-subscriptions/move', this.move, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          this.move = false
          this.move_result = data.result

          this.load()
        }
      })
    },
    isInPast (date) {
    	const dt = new Date(date)

    	return dt.getTime() < (new Date()).getTime()
    },
    open (date, records, country) {
      this.move = {
        date: date,
        count: records.length,
        records: records,
        move_count: records.length,
        move_to_date: Vue.$create.dateTime(date).addDays(1).format('Y-m-d'),
        country_id: country.id
      }
    },
    load () {
      var url = '/new-subscriptions/statistics/renewals?'

      url += 'from=' + this.request.from
      url += '&to=' + this.request.to

      Vue.$api.get(url, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data
    }
  },
  created () {
    var date = Vue.$create.dateTime(new Date())

    this.request.from = date.format('Y-m-d')
    this.request.to = date.addDays(30).format('Y-m-d')

    this.load()
  }
}
</script>
